import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Tab, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
var OrderTabs = function (_a) {
    var pathPrefix = _a.pathPrefix, tab = _a.tab, orderContent = _a.orderContent, orderPricesContent = _a.orderPricesContent, invoicesContent = _a.invoicesContent, onReload = _a.onReload;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var handleTabChange = React.useCallback(function (_, value) {
        if (onReload)
            onReload();
        var url = value === 'order' ? pathPrefix : "".concat(pathPrefix, "/").concat(value);
        navigate(url);
    }, [onReload, navigate, pathPrefix]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Tabs, { value: tab, onChange: handleTabChange, indicatorColor: "primary", textColor: "primary", variant: "fullWidth" },
            React.createElement(Tab, { label: t('orderInformation'), value: "order" }),
            React.createElement(Tab, { label: t('orderPrices'), value: "orderPrices" }),
            React.createElement(Tab, { label: t('invoices'), value: "invoices" })),
        React.createElement(Box, { my: 4 },
            tab === 'order' && orderContent,
            tab === 'orderPrices' && orderPricesContent,
            tab === 'invoices' && invoicesContent)));
};
export default OrderTabs;
